import { createSlice } from '@reduxjs/toolkit'
import { WorkflowTaskStatusState } from '../types/workflow/workflowTaskStatus.types'

const initialState: WorkflowTaskStatusState = {
  workflowTaskStates: [],
}

const workflowTaskStatusSlice = createSlice({
  name: 'workflowTaskStatus',
  initialState: initialState,
  reducers: {
    setWorkflowStatus: (state: WorkflowTaskStatusState, action) => {
      state.workflowTaskStates = action.payload
    },
  },
})

export const { setWorkflowStatus } = workflowTaskStatusSlice.actions
export default workflowTaskStatusSlice.reducer
